<template>
  <div class="sc-menu">
    <el-menu
      router
      :unique-opened="true"
      default-active="home"
      class="menu" :collapse="isCollapse" background-color="#324157" text-color="#bfcbd9">
      <!-- el-menu-item index="home"><i class="iconfont icon-home"></i> <span>概览</span></el-menu-item -->
      <el-submenu index="resource.manage">
        <template slot="title">
          <i class="iconfont icon-ziliaoku"></i>
          <span>培训资料</span>
        </template>
        <el-menu-item index="/resource/list">资料一览</el-menu-item>
        <el-menu-item index="/resource/category">资料分类</el-menu-item>
      </el-submenu>
      <el-submenu index="customer.manage">
        <template slot="title">
          <i class="iconfont icon-kaoshi"></i>
          <span>测试管理</span>
        </template>
        <el-menu-item index="/test/list">测试</el-menu-item>
        <el-menu-item index="/testPaper/list">试卷</el-menu-item>
        <el-menu-item index="/question/list">题库</el-menu-item>
        <el-menu-item index="/question/category">试题分类</el-menu-item>
        <el-menu-item index="/test/result">测试统计</el-menu-item>
      </el-submenu>
      <el-submenu index="report.manage">
        <template slot="title">
          <i class="iconfont icon-shangbao"></i>
          <span>事故上报</span>
        </template>
        <el-menu-item index="/report/list">上报一览</el-menu-item>
      </el-submenu>
      <el-submenu index="article.manage">
        <template slot="title">
          <i class="iconfont icon-share"></i>
          <span>分享管理</span>
        </template>
        <el-menu-item index="/article/category">文章分类</el-menu-item>
        <el-menu-item index="/article/list">文章一览</el-menu-item>
        <!--el-menu-item index="/marketing/message">评论审核</el-menu-item-->
      </el-submenu>
      <el-submenu index="system.manage">
        <template slot="title">
          <i class="iconfont icon-people"></i>
          <span>用户管理</span>
        </template>
        <el-menu-item index="/user/manage">用户列表</el-menu-item>
        <!-- el-menu-item index="/role/manage">角色管理</el-menu-item -->
        <el-menu-item index="/region/manage">区域管理</el-menu-item>
        <el-menu-item index="/department/manage">部门管理</el-menu-item>
      </el-submenu>
      <!-- el-submenu index="system.manage">
        <template slot="title">
          <i class="iconfont icon-settings"></i>
          <span >系统管理</span>
        </template>
        <el-menu-item index="status.view">系统状态</el-menu-item>
        <el-menu-item index="database.backup">数据库备份</el-menu-item>
      </el-submenu -->
    </el-menu>
  </div>
</template>

<script type="text/babel">

export default {
  name: 'KyMenu',
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.sc-menu
  position: fixed
  z-index: 100
  background-color: #324157
  height: 100%
  &::-webkit-scrollbar
    width: 5px
    height: 5px
  .el-menu:not(.el-menu--collapse)
    width: 200px
  .menu
    border-right: none
</style>



// WEBPACK FOOTER //
// src/components/KyMenu.vue